<template>
  <div>
    <div class="mb-4">
      <inertia-link :href="route('admin.inventory')" class="rounded p-2 mb-3 border">back</inertia-link>
    </div>
    <h1 class="mb-8 font-bold text-3xl">Brands & Product Inventory</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter only-search v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-filter>
    </div>

    <div class="grid md:grid-cols-3 lg:grid-cols-6 gap-2">

      <inertia-link :href="route('admin.inventory.brands.items',{brand: brand.code})" v-for="brand in brands" :key="brand.name" class="p-3 bg-white shadow-sm rounded-lg flex flex-row justify-between">

        <div class="flex-grow-1">
          <h1>{{ brand.name }}</h1>
          <p class="text-sm text-gray-400 mt-1">#Items : {{ brand.count }}</p>
        </div>
        <div class="flex items-center">
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
        </div>

      </inertia-link>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import SearchFilter from '@/Shared/SearchFilter'
  import throttle from 'lodash/throttle'
  import pickBy from 'lodash/pickBy'
  import Icon from '@/Shared/Icon'
  import mapValues from 'lodash/mapValues'

  export default {
    layout: Layout,
    components: {
      SearchFilter,
      Icon
    },
    props: {
      filters: Object,
      brands: Array,
    },

    data() {
      return {
        form: {
          country: null,
          search : this.filters.search,
        }
      }
    },

    watch: {
      form: {
        handler: throttle(function () {
          let query = pickBy(this.form)
          this.$inertia.get(this.route('admin.inventory.brands', Object.keys(query).length ? query : { remember: 'forget' } ), {}, { preserveState: true })
        }, 150),
        deep: true,
      },
    },

    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
    },
  }
</script>
